import React from "react";
import SortableItem from "./SortItem";

import { SortableContainer } from "react-sortable-hoc";

const SortableList = SortableContainer(props => {
  let { items, removeItem, setFileName, hasProgress } = props;

  if (items.length !== 0) {
    console.log(items);
    return (
      <div className="uploaded-files">
        {items.map((file, index) => (
          <SortableItem
            key={`item-${index}`}
            index={index}
            value={file}
            hasProgress={hasProgress}
            sortIndex={index}
            setFileName={setFileName}
            removeItem={removeItem}
          />
        ))}
      </div>
    );
  } else {
    return <div />;
  }
});

export default SortableList;



// WEBPACK FOOTER //
// ./src/system/fields/FileUpload/SortList.jsx